export const programTypes = {
    rsv_course: {
        key: 'course',
        icon: require('@/assets/images/account-track/icon/program/course.svg'),
        completeIcon: require('@/assets/images/account-track/icon/check/course.svg'),
        bgColor: '#F27E8240',
        markerColor: '#F27E82',
        text: 'Онлайн-курс РСВ',
        shortText: 'Онлайн-курс РСВ',
        xsText: 'Онлайн-курс',
    },
    rsv_webinar: {
        key: 'webinar',
        icon: require('@/assets/images/account-track/icon/program/webinar.svg'),
        completeIcon: require('@/assets/images/account-track/icon/check/webinar.svg'),
        bgColor: '#4ACFC240',
        markerColor: '#4ACFC2',
        text: 'Вебинар',
        shortText: 'Вебинар',
    },
    higher: {
        key: 'higher',
        icon: require('@/assets/images/account-track/icon/program/higher.svg'),
        completeIcon: require('@/assets/images/account-track/icon/check/higher.svg'),
        bgColor: '#5EC1F940',
        markerColor: '#5EC1F9',
        text: 'Высшее образование',
        shortText: 'Высшее',
    },
    secondary: {
        key: 'secondary',
        icon: require('@/assets/images/account-track/icon/program/secondary.svg'),
        completeIcon: require('@/assets/images/account-track/icon/check/secondary.svg'),
        bgColor: '#EAA52040',
        markerColor: '#EAA520',
        text: 'Среднее профессиональное',
        shortText: 'Среднее профессиональное',
    },
    additional: {
        key: 'additional',
        icon: require('@/assets/images/account-track/icon/program/additional.svg'),
        completeIcon: require('@/assets/images/account-track/icon/check/additional.svg'),
        bgColor: '#AF77E140',
        markerColor: '#AF77E1',
        text: 'Дополнительное образование',
        shortText: 'Дополнительное',
    },
};